export default __webpack_public_path__ + "static/rishi-goutam-resume-6b18f6247cb6a9a8a4574218f6baa5b1.pdf";